/**
 * Enumeração que define os tipos de usuário no sistema
 * EMPRESA: Usuário padrão que representa uma empresa
 * CONSULTOR: Usuário que atua como consultor e pode ter clientes vinculados
 */
export enum TipoUsuario {
  EMPRESA = 'EMPRESA',
  CONSULTOR = 'CONSULTOR'
}